import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import { getTermsOfUse, TERMS_OF_USE_TAGS, updateTermsOfUse } from './endpoints';

const termOfUseApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getTermsOfUse: getTermsOfUse(builder),
      updateTermsOfUse: updateTermsOfUse(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [TERMS_OF_USE_TAGS],
  });

export const { useGetTermsOfUseQuery, useUpdateTermsOfUseMutation } = termOfUseApi;
